import * as React from 'react';
import emptyImg from '@images/icon/icon_notice_none.png';

export type EmptyProps = {
  text: React.ReactNode;
  imgUrl: string;
  size: 'default' | 'small';
};

const CustomizeEmpty = ({ text, imgUrl, size }: EmptyProps) => {
  return (
    <div className={`custom-empty ${size}`}>
      <div>
        <img src={imgUrl} alt="no data" />
        <p>{text}</p>
      </div>
    </div>
  );
};

CustomizeEmpty.defaultProps = {
  text: '목록이 없습니다.',
  imgUrl: emptyImg,
  size: 'default',
};

export default CustomizeEmpty;
